<template>
  <div class="md-6" style="position: relative;">
    <canvas class="myCanvas"> </canvas>
    <md-tooltip md-direction="right"> {{ mesure }} {{ refunity }} </md-tooltip>
  </div>
</template>

<script>
export default {
  name: "ruler-widget",
  props: ["sceneWidth", "sceneHeight", "refunity"],
  mixins: [],
  components: {},
  data() {
    return {
      mousestartx: 0,
      mousestarty: 0,
      firstClick: false,
      mesure: 0,
      perspective: 0,
      // ratioperspective représente le degré de différence de point de vue entre le haut de l'image et le bas de l'image.
      // exemple: un ratio de 0.5 signifie qu'une ligne de 5cm en bas de l'image, qui aura une largeur de 200px, n'aura qu'une largeur de
      // 100 px en haut de l'image.
      ratioperspective: 1
    };
  },
  async mounted() {
    window.addEventListener("resize", () => {
      this.rulerInPlace();
    });
  },
  methods: {
    rulerInPlace() {
      var parent = document.getElementsByClassName("video-js");

      let isDrawing = false;
      let x = 0;
      let y = 0;

      const canvas = document.querySelector(".myCanvas");
      const ctx = canvas.getContext("2d");
      canvas.width = parent[0].offsetWidth;
      canvas.height = parent[0].offsetHeight;
      canvas.style.marginTop = (0 - parent[0].offsetHeight).toString() + "px";
      // event.offsetX, event.offsetY gives the (x,y) offset from the edge of the canvas.

      // Add the event listeners for mousedown, mousemove, and mouseup
      canvas.addEventListener("mousedown", e => {
        x = e.offsetX;
        y = e.offsetY;
        isDrawing = true;
      });

      canvas.addEventListener("mousemove", e => {
        if (isDrawing === true) {
          ctx.beginPath();
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.moveTo(x, y);
          var rect = canvas.getBoundingClientRect();
          ctx.lineTo(
            (e.clientX - rect.left) * (canvas.width / rect.width),
            (e.clientY - rect.top) * (canvas.height / rect.height)
          );

          ctx.stroke();
        }
      });

      window.addEventListener("mouseup", e => {
        if (isDrawing === true) {
          drawLine(ctx, x, y, e.offsetX, e.offsetY);

          isDrawing = false;

          var largeur = Math.abs(
            ((x - e.offsetX) * this.sceneWidth) / canvas.width
          );
          var hauteur = Math.abs(
            ((y - e.offsetY) * this.sceneHeight) / canvas.height
          );
          this.mesure = Math.sqrt(Math.pow(largeur, 2) + Math.pow(hauteur, 2));
          this.perspective = (canvas.height - e.offsetY) / canvas.height;
        }
      });

      function drawLine(context, x1, y1, x2, y2) {
        ctx.beginPath();
        ctx.strokeStyle = "orange";
        ctx.lineWidth = 2;
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.closePath();
      }
    }
  }
};
</script>
